module.exports = __webpack_public_path__ + "img/mypage-message-guide.874cf41f.png";